import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

const styles = makeStyles()((theme) => ({
  logoWrapper: {
    position: 'relative',
    display: 'inline-block',
    width: 'fit-content',
    verticalAlign: 'middle',
  },
  baseSvg: {
    position: 'relative',
    display: 'block',
  },
  glitchSvg: {
    position: 'absolute',
    top: 0,
    left: 0,
    opacity: 0,
  },
  neonFlicker: {
    //filter: 'url(#noiseFilter)',
    animation: '$neonFlicker 1s steps(1) infinite alternate-reverse',
  },
  glitchRGB: {
    filter:
      'drop-shadow(-2px 3px red) drop-shadow(2px -1px blue) drop-shadow(-1px -1px black)',
    animation: '$glitchRGB 1s steps(1) infinite alternate-reverse',
    opacity: 1,
  },
  glitch1: {
    filter: 'drop-shadow(-3px 0px 1px white)',
    animation: '$glitch1 1s steps(1) infinite alternate-reverse',
    opacity: 1,
  },
  glitch2: {
    filter: 'drop-shadow(3px 0px white)',
    animation: '$glitch2 1s steps(2) infinite alternate',
    opacity: 1,
  },
  glitch3: {
    filter: 'brightness(100%) saturate(100%)', // Makes it black
    animation: '$glitch3 1s steps(2) infinite alternate-reverse',
    opacity: 1,
  },
  '@keyframes glitchRGB': {
    '0%': { clipPath: 'inset(0 0 90% 0)' },
    '20%': { clipPath: 'inset(0 0 50% 0)' },
    '40%': { clipPath: 'inset(0 0 20% 0)' },
    '50%': { clipPath: 'inset(0 0 0 0)' },
    '60%': { clipPath: 'inset(10% 0 80% 0)' },
    '80%': { clipPath: 'inset(50% 0 30% 0)' },
    '90%': { clipPath: 'inset(0 0 0 0)' },
    '100%': { clipPath: 'inset(0% 0 90% 0)' },
  },
  '@keyframes glitch1': {
    '0%': { clipPath: 'inset(99% 15% 0 1%)' },
    '20%': { clipPath: 'inset(40% 65% 40% 0)' },
    '40%': { clipPath: 'inset(20% 35% 60% 2%)' },
    '50%': { clipPath: 'inset(5% 55% 0 93%)' },
    '60%': { clipPath: 'inset(70% 10% 10% 0)' },
    '70%': { clipPath: 'inset(40% 65% 59% 1%)' },
    '80%': { clipPath: 'inset(30% 85% 69% 0)' },
    '90%': { clipPath: 'inset(20% 35% 60% 2%)' },
    '100%': { clipPath: 'inset(0 5% 98% 1%)' },
  },
  '@keyframes glitch2': {
    '0%': { clipPath: 'inset(65% 1% 28% 15%)' },
    '20%': { clipPath: 'inset(45% 0 40% 65%)' },
    '40%': { clipPath: 'inset(20% 3% 68% 35%)' },
    '50%': { clipPath: 'inset(0 0 0 95%)' },
    '60%': { clipPath: 'inset(75% 1% 15% 10%)' },
    '70%': { clipPath: 'inset(30% 0 69% 65%)' },
    '80%': { clipPath: 'inset(20% 2% 79% 5%)' },
    '90%': { clipPath: 'inset(38% 0 50% 35%)' },
    '100%': { clipPath: 'inset(10% 1% 89% 25%)' },
  },
  '@keyframes glitch3': {
    '0%': { clipPath: 'inset(10% 0 85% 0)' },
    '10%': { clipPath: 'inset(20% 10% 60% 0)' },
    '20%': { clipPath: 'inset(5% 80% 75% 15%)' },
    '30%': { clipPath: 'inset(30% 30% 40% 0)' },
    '40%': { clipPath: 'inset(50% 5% 30% 0)' },
    '50%': { clipPath: 'inset(60% 0 25% 0)' },
    '60%': { clipPath: 'inset(15% 10% 70% 65%)' },
    '70%': { clipPath: 'inset(40% 0 45% 18%)' },
    '80%': { clipPath: 'inset(25% 35% 55% 10%)' },
    '90%': { clipPath: 'inset(10% 0 85% 0)' },
    '100%': { clipPath: 'inset(0% 5% 100% 45%)' },
  },
  '@keyframes neonFlicker': {
    '0%': { opacity: 1, filter: 'brightness(0.5)' },
    '10%': { opacity: 0, filter: 'brightness(1.5)' },
    '15%': { opacity: 0.4, filter: 'brightness(0.7)' },
    '20%': { opacity: 1, filter: 'brightness(1.2)' },
    '25%': { opacity: 0.2, filter: 'brightness(0.5)' },
    '30%': { opacity: 1, filter: 'brightness(1.5)' },
    '35%': { opacity: 0.7, filter: 'brightness(1)' },
    '40%': { opacity: 1, filter: 'brightness(1.5)' },
    '100%': { opacity: 0, filter: 'brightness(1.5)' }, // Fully "on"
  },
}));

export default styles;
